import { format, parse, isValid } from 'date-fns';

/**
 * Formats an ISO date string to MM/DD/YY format
 * @param isoDateString ISO date string (e.g., 2025-03-12T06:34:52.499Z)
 * @returns Formatted date string (e.g., 03/12/25)
 */
export function formatPaymentDate(isoDateString: string): string {
    if (!isoDateString) return '';

    const date = new Date(isoDateString);

    // Handle invalid date
    if (isNaN(date.getTime())) return '';

    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-11
    const day = String(date.getDate()).padStart(2, '0');
    // Get last 2 digits of year
    const year = date.getFullYear() % 100;
    const yearStr = String(year).padStart(2, '0');

    return `${month}/${day}/${yearStr}`;
}

/**
 * Formats a date string to MM/DD/YYYY format specifically for CSV export
 * @param dateString Date string in various formats (e.g., 2025-03-12T06:34:52.499Z, 2008-8-25, 08/29/25)
 * @returns Formatted date string (e.g., 03/12/2025)
 */
export function formatPaymentDateForCSV(dateString: string): string {
    if (!dateString) return '';

    let date: Date;

    // Check if it's already in MM/DD/YY format
    if (/^\d{1,2}\/\d{1,2}\/\d{2}$/.test(dateString)) {
        const parsedDate = parse(dateString, 'MM/dd/yy', new Date());
        date = isValid(parsedDate) ? parsedDate : new Date(dateString);
    } else {
        // Handle other formats (ISO, YYYY-M-D, etc.)
        date = new Date(dateString);
    }

    // Handle invalid date
    if (!isValid(date)) return '';

    return format(date, 'MM/dd/yyyy');
}
